@if (incomeTaxEntity$ | async) {
  @if (heeftOndernemingen) {
    <div class="row">
      <div class="col-auto col col-1" style="font-weight: bold">
      </div>
      <div class="col-auto col-2">
      </div>
      <div class="col-auto col-4" style="font-weight: bold">
        {{ labelBalansSlot }}
      </div>
      <div class="col-auto col-3" style="font-weight: bold">
        {{ labelBalansOpening }}
      </div>
      <div class="col-auto col-4"></div>
    </div>

    <form [formGroup]="eigenVermogenFg">
      <div class="row">
        <div class="col-auto col col-1 pt-2">
          Berekend ondernemingsvermogen (excl. reserves)
        </div>
        <div class="col-auto col-2">
          <div style="height: 20px; width: 160px"></div>
        </div>
        <div class="col-auto col-3 pt-2" style="font-weight: bold">
          <snelstart-ui-number-form-control [decimals]="0"
                                            [calculate]="getTotaalEvSlot()"
                                            align="right"
                                            class="col-auto custom-input-150"
                                            formControlName="waardeSlot"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto col-4 pt-2" style="font-weight: bold">
          <snelstart-ui-number-form-control [decimals]="0"
                                            [calculate]="getTotaalEvOpening()"
                                            align="right"
                                            class="col-auto custom-input-150"
                                            formControlName="waardeOpening"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto col-4"></div>
      </div>
    </form>
    <form [formGroup]="kostenEgalisatieReserveFg">
      <div class="row">
        <div class="col-auto col col-1">
          <p>Egalisatiereserve</p>
        </div>
        <div class="col-auto col-2">
          <snelstart-venture-fiscaal-feature-spec-egalisatiereserve></snelstart-venture-fiscaal-feature-spec-egalisatiereserve>
        </div>
        <div class="col-auto col-3">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="col-auto custom-input-150"
                                            formControlName="waardeSlot"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto col-4">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="col-auto custom-input-150"
                                            formControlName="waardeOpening"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto col-4"></div>
      </div>
    </form>

    <form [formGroup]="herinvesteringsReserveFg">
      <div class="row">
        <div class="col-auto col col-1">
          <p>Herinvesteringsreserve</p>
        </div>
        <div class="col-auto col-2">
          <snelstart-venture-fiscaal-feature-spec-hir-ib></snelstart-venture-fiscaal-feature-spec-hir-ib>
        </div>
        <div class="col-auto col-3">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="col-auto custom-input-150"
                                            formControlName="waardeSlot"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto col-4">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="col-auto custom-input-150"
                                            formControlName="waardeOpening"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto col-4"></div>
      </div>
    </form>

    <form [formGroup]="oudedagesReserveaFg">
      <div class="row">
        <div class="col-auto col col-1">
          <p>Oudedagsreserve</p>
        </div>
        <div class="col-auto col-2">
          <snelstart-venture-fiscaal-feature-spec-for></snelstart-venture-fiscaal-feature-spec-for>
        </div>
        <div class="col-auto col-3">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="col-auto custom-input-150"
                                            formControlName="waardeSlot"
                                            prefix="€"

          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto col-4">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="col-auto custom-input-150"
                                            formControlName="waardeOpening"
                                            prefix="€"

          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto col-4"></div>
      </div>
    </form>

    <form [formGroup]="garantieVoorzieningFg">
      <div class="pt-1">
        <div class="row">
          <div class="col-auto col col-1">
            <p>Garantievoorziening</p>
          </div>
          <div class="col-auto col-2">
            <div style="height: 20px; width: 160px"></div>
          </div>
          <div class="col-auto col-3">
            <snelstart-ui-number-form-control [decimals]="0"
                                              align="right"
                                              class="col-auto custom-input-150"
                                              formControlName="waardeSlot"
                                              prefix="€"

            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-auto col-4">
            <snelstart-ui-number-form-control [decimals]="0"
                                              align="right"
                                              class="col-auto custom-input-150"
                                              formControlName="waardeOpening"
                                              prefix="€"

            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-auto col-4"></div>
        </div>

      </div>
    </form>
    <form [formGroup]="overigeVoorzieningenFg">

      <div class="row">
        <div class="col-auto col col-1">
          <p>Overige voorzieningen</p>
        </div>
        <div class="col-auto col-2">
          <div style="height: 20px; width: 160px"></div>
        </div>
        <div class="col-auto col-3">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="col-auto custom-input-150"
                                            formControlName="waardeSlot"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto col-4">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="col-auto custom-input-150"
                                            formControlName="waardeOpening"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto col-4"></div>
      </div>
    </form>

    <form [formGroup]="schuldenLanglopendKredietinstellingenFg">

      <div class="row">
        <div class="col-auto col col-1 pt-2">
          <p>Langlopende schulden kredietinstellingen</p>
        </div>
        <div class="col-auto col-2">
          <div style="height: 20px; width: 160px"></div>
        </div>
        <div class="col-auto col-3 pt-3">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="col-auto custom-input-150"
                                            formControlName="waardeSlot"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto col-4 pt-3">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="col-auto custom-input-150"
                                            formControlName="waardeOpening"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto col-4"></div>
      </div>
    </form>
    <form [formGroup]="schuldenLanglopendOverigFg">

      <div class="row">
        <div class="col-auto col col-1">
          <p>Overige langlopende schulden</p>
        </div>
        <div class="col-auto col-2">
          <div style="height: 20px; width: 160px"></div>
        </div>
        <div class="col-auto col-3">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="col-auto custom-input-150"
                                            formControlName="waardeSlot"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto col-4">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="col-auto custom-input-150"
                                            formControlName="waardeOpening"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto col-4"></div>
      </div>
    </form>
    <form [formGroup]="crediteurenFg">
      <div class="pt-1">
        <div class="row">
          <div class="col-auto col col-1">
            <p>Crediteuren</p>
          </div>
          <div class="col-auto col-2">
            <div style="height: 20px; width: 160px"></div>
          </div>
          <div class="col-auto col-3">
            <snelstart-ui-number-form-control [decimals]="0"
                                              align="right"
                                              class="col-auto custom-input-150"
                                              formControlName="waardeSlot"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-auto col-4">
            <snelstart-ui-number-form-control [decimals]="0"
                                              align="right"
                                              class="col-auto custom-input-150"
                                              formControlName="waardeOpening"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-auto col-4"></div>
        </div>
      </div>
    </form>
    <form [formGroup]="schuldenOmzetbelastingFg">

      <div class="row">
        <div class="col-auto col col-1">
          <p>Omzetbelasting</p>
        </div>
        <div class="col-auto col-2">
          <snelstart-venture-fiscaal-feature-spec-omzetbelasting-passiva></snelstart-venture-fiscaal-feature-spec-omzetbelasting-passiva>
        </div>
        <div class="col-auto col-3">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="col-auto custom-input-150"
                                            formControlName="waardeSlot"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto col-4">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="col-auto custom-input-150"
                                            formControlName="waardeOpening"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto col-4"></div>
      </div>
    </form>
    <form [formGroup]="schuldenLoonheffingenFg">

      <div class="row">
        <div class="col-auto col col-1">
          <p>Loonheffingen</p>
        </div>
        <div class="col-auto col-2">
          <div style="height: 20px; width: 160px"></div>
        </div>
        <div class="col-auto col-3">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="col-auto custom-input-150"
                                            formControlName="waardeSlot"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto col-4">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="col-auto custom-input-150"
                                            formControlName="waardeOpening"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto col-4"></div>
      </div>
    </form>
    <form [formGroup]="schuldenKortlopendOverigFg">
      <div class="row">
        <div class="col-auto col col-1">
          <p>Overige kortlopende schulden</p>
        </div>
        <div class="col-auto col-2">
          <div style="height: 20px; width: 160px"></div>
        </div>
        <div class="col-auto col-3">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="col-auto custom-input-150"
                                            formControlName="waardeSlot"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto col-4">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="col-auto custom-input-150"
                                            formControlName="waardeOpening"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-auto col-4"></div>
      </div>
    </form>

    <form [formGroup]="totalFg">
      <div class="pt-1">
        <div class="row">
          <div class="col-auto col col-1">
            @if (!heeftSamenwerkingsverband) {
              <b>Totaal passiva</b>
            } @else {
              <b>Totaal passiva samenwerkingsverband</b>
            }
          </div>
          <div class="col-auto col-2">
            <p></p>
          </div>
          <div class="col-auto col-3">
            <snelstart-ui-number-form-control [decimals]="0"
                                              [calculate]="getTotaalPassivaSlot()"
                                              [disabledControl]="true"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="totaalSlot"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-auto col-4">
            <snelstart-ui-number-form-control [decimals]="0"
                                              [calculate]="getTotaalPassivaOpening()"
                                              [disabledControl]="true"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="totaalOpening"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-auto col-4"></div>
        </div>
      </div>
    </form>
  } @else {
    <p>Er zijn geen ondernemingen gevonden.</p>
  }
}
